import React, { createContext, useContext, useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../config/firebase';
import { APP_NAME } from '../config/constants'; 

const CompanyContext = createContext();

export const useCompany = () => useContext(CompanyContext);

export const CompanyProvider = ({ children }) => {
    const [companyData, setCompanyData] = useState({
        name: APP_NAME,
        logoUrl: null,
        watermarkUrl: null,
        colors: {
            primary: '#2563EB',
            secondary: '#1E40AF',
            accent: '#F59E0B',
            font: '#1F2937'
        },
        integrations: {
            emailJsServiceId: '',
            emailJsTemplateId: '',
            emailJsPublicKey: ''
        },
        // NUEVO: Configuración por defecto de la Landing Page
        landingConfig: [
            { id: 'hero', label: 'Bienvenida (Hero)', enabled: true },
            { id: 'services', label: 'Servicios', enabled: true },
            { id: 'about', label: 'Sobre Nosotros', enabled: true },
            { id: 'projects', label: 'Proyectos / Industrias', enabled: true },
            { id: 'contact', label: 'Contacto', enabled: true }
        ],
        loading: true
    });

    useEffect(() => {
        const unsubscribe = onSnapshot(doc(db, 'parameters', 'system-settings'), (docSnap) => {
            if (docSnap.exists()) {
                const data = docSnap.data();
                
                setCompanyData({
                    name: data.companyName || APP_NAME,
                    logoUrl: data.companyLogoUrl || null,
                    watermarkUrl: data.watermarkUrl || null,
                    colors: {
                        primary: data.primaryColor || '#2563EB',
                        secondary: data.secondaryColor || '#1E40AF',
                        accent: data.accentColor || '#F59E0B',
                        font: data.fontColor || '#1F2937'
                    },
                    integrations: {
                        emailJsServiceId: data.emailJsServiceId || process.env.REACT_APP_EMAILJS_SERVICE_ID || '',
                        emailJsTemplateId: data.emailJsTemplateId || process.env.REACT_APP_EMAILJS_TEMPLATE_ID || '',
                        emailJsPublicKey: data.emailJsPublicKey || process.env.REACT_APP_EMAILJS_PUBLIC_KEY || ''
                    },
                    // Leemos la configuración guardada o usamos la por defecto
                    landingConfig: data.landingConfig || [
                        { id: 'hero', label: 'Bienvenida (Hero)', enabled: true },
                        { id: 'services', label: 'Servicios', enabled: true },
                        { id: 'about', label: 'Sobre Nosotros', enabled: true },
                        { id: 'projects', label: 'Proyectos / Industrias', enabled: true },
                        { id: 'contact', label: 'Contacto', enabled: true }
                    ],
                    loading: false
                });
                
            } else {
                setCompanyData(prev => ({ ...prev, loading: false }));
            }
        }, (error) => {
            console.error("Error leyendo configuración de empresa:", error);
            setCompanyData(prev => ({ ...prev, loading: false }));
        });

        return () => unsubscribe();
    }, []);

    return (
        <CompanyContext.Provider value={companyData}>
            {children}
        </CompanyContext.Provider>
    );
};